import SignupForm from "./SignupForm.view";

export default SignupForm;
